/* ESSCENTUM — "The Issue" behaviour (vanilla JS, no dependencies).
   Add to bag goes through Allure's own cart API (window.themeCore.CartApi).
   Also: acts tabs, the question, shelf filters (house, family, mood, season, occasion, note) + sort, product pop-up (size + quantity).
   The Archive also reads its filter from the address (/#archive?family=Woody) — the main menu links there. */
(function () {
  if (window.EssIssue) { return; }
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var split = function (s) { return (s || '').split('|').filter(Boolean); };

  var products = {};
  function readProducts(root) {
    $$('script[data-ess-products]', root).forEach(function (el) {
      try { JSON.parse(el.textContent).forEach(function (p) { products[p.handle] = p; }); } catch (e) {}
    });
  }

  function initActs(sec) {
    var tabs = $$('[data-ess-act-tab]', sec);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !on; }
        });
      });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          n.focus(); n.click();
        }
      });
    });
  }

  function initQuestion(sec) {
    var picks = { mood: null, season: null, note: null };
    var cards = $$('[data-ess-card]', sec);
    var empty = $('[data-ess-q-empty]', sec);
    var emptyText = empty ? empty.textContent : '';
    var reset = $('[data-ess-q-reset]', sec);
    var ROMAN = ['I', 'II', 'III'];
    function run() {
      var asked = (picks.mood ? 1 : 0) + (picks.season ? 1 : 0) + (picks.note ? 1 : 0);
      cards.forEach(function (c) { c.hidden = true; c.style.order = ''; });
      empty.hidden = asked > 0; empty.textContent = emptyText;
      reset.hidden = asked === 0;
      if (!asked) { return; }
      var scored = cards.map(function (c) {
        var sc = 0, why = [], hits = 0;
        if (picks.mood && split(c.dataset.mood).indexOf(picks.mood) >= 0) { sc += 3; hits++; why.push(picks.mood.toLowerCase()); }
        if (picks.season && split(c.dataset.season).indexOf(picks.season) >= 0) { sc += 2; hits++; why.push(picks.season.toLowerCase()); }
        if (picks.note && split(c.dataset.notes).indexOf(picks.note) >= 0) { sc += 2; hits++; why.push(picks.note.toLowerCase()); }
        return { c: c, sc: sc, why: why, hits: hits, year: +c.dataset.year || 0 };
      }).filter(function (x) { return x.sc > 0; }).sort(function (a, b) { return b.sc - a.sc || b.year - a.year; });
      var out = [], seen = {};
      scored.forEach(function (x) { if (out.length < 3 && !seen[x.c.dataset.house]) { seen[x.c.dataset.house] = 1; out.push(x); } });
      scored.forEach(function (x) { if (out.length < 3 && out.indexOf(x) < 0) { out.push(x); } });
      out.forEach(function (x, i) {
        x.c.hidden = false; x.c.style.order = i;
        var w = $('[data-ess-why]', x.c);
        if (w) { w.textContent = ROMAN[i] + ' · ' + x.why.join(' · '); }
      });
      if (!out.length) { empty.hidden = false; empty.textContent = 'Nothing answers all of that. Loosen one answer.'; }
    }
    $$('[data-ess-q]', sec).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var k = chip.dataset.essQ, v = chip.dataset.value;
        picks[k] = picks[k] === v ? null : v;
        $$('[data-ess-q="' + k + '"]', sec).forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.value === picks[k] ? 'true' : 'false'); });
        run();
      });
    });
    reset.addEventListener('click', function () {
      picks = { mood: null, season: null, note: null };
      $$('[data-ess-q]', sec).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      run();
    });
    run();
  }

  var ATTR = { house: 'house', family: 'family', mood: 'mood', season: 'season', occasion: 'occasion', note: 'notes' };
  var MULTI = { mood: 1, season: 1, occasion: 1, note: 1 };
  function initShelf(sec) {
    var st = { f: {}, sort: 'edit', pages: 1 };
    var per = function () { return window.matchMedia('(max-width: 749px)').matches ? (+sec.dataset.perMobile || 6) : (+sec.dataset.perDesktop || 8); };
    var cards = $$('[data-ess-card]', sec);
    var selects = $$('[data-ess-filter]', sec);
    var more = $('[data-ess-more]', sec), moreN = $('[data-ess-more-n]', sec), none = $('[data-ess-none]', sec);
    var active = $('[data-ess-active]', sec), activeTags = $('[data-ess-active-tags]', sec);
    var box = $('[data-ess-filters]', sec), toggle = $('[data-ess-filters-toggle]', sec), toggleN = $('[data-ess-filters-n]', sec);
    function matches(c) {
      for (var k in st.f) {
        if (!st.f[k]) { continue; }
        var v = c.dataset[ATTR[k]] || '';
        if (MULTI[k] ? split(v).indexOf(st.f[k]) < 0 : v !== st.f[k]) { return false; }
      }
      return true;
    }
    function sync() { selects.forEach(function (s) { s.value = st.f[s.dataset.essFilter] || ''; }); }
    function render() {
      var list = cards.filter(matches);
      var key = { edit: function (c) { return +c.dataset.index; }, low: function (c) { return +c.dataset.price; }, high: function (c) { return -c.dataset.price; }, 'new': function (c) { return -(+c.dataset.year || 0); } }[st.sort];
      list.sort(function (a, b) { return key(a) - key(b) || (+a.dataset.index - +b.dataset.index); });
      var limit = per() * st.pages;
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c, i) { c.style.order = i; c.hidden = i >= limit; });
      more.hidden = list.length <= limit;
      moreN.textContent = Math.max(0, list.length - limit);
      none.hidden = list.length > 0;
      var keys = Object.keys(st.f).filter(function (k) { return st.f[k]; });
      active.hidden = !keys.length;
      if (toggleN) { toggleN.textContent = keys.length ? '(' + keys.length + ')' : ''; }
      activeTags.innerHTML = '';
      if (keys.length) {
        var n = document.createElement('span');
        n.textContent = list.length + (list.length === 1 ? ' scent' : ' scents');
        n.style.cssText = 'font-style: italic; margin-right: 6px';
        activeTags.appendChild(n);
      }
      keys.forEach(function (k) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ess-chip';
        b.setAttribute('aria-label', 'Remove filter ' + st.f[k]);
        b.textContent = st.f[k] + ' ×';
        b.addEventListener('click', function () { st.f[k] = ''; sync(); st.pages = 1; render(); });
        activeTags.appendChild(b);
      });
    }
    cards.forEach(function (c, i) { c.dataset.index = i; });
    selects.forEach(function (s) { s.addEventListener('change', function () { st.f[s.dataset.essFilter] = s.value; st.pages = 1; render(); }); });
    var sel = $('[data-ess-sort]', sec);
    if (sel) { sel.addEventListener('change', function () { st.sort = sel.value; st.pages = 1; render(); }); }
    more.addEventListener('click', function () { st.pages++; render(); });
    $$('[data-ess-clear]', sec).forEach(function (b) { b.addEventListener('click', function () { st.f = {}; sync(); st.pages = 1; render(); }); });
    if (toggle) { toggle.addEventListener('click', function () { var o = box.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', o ? 'true' : 'false'); toggle.lastElementChild.textContent = o ? '−' : '+'; }); }
    function fromHash() {
      var m = /[?&](house|family|mood|season|occasion|note)=([^&]+)/.exec(window.location.hash || '');
      if (!m) { return false; }
      st.f = {}; st.f[m[1]] = decodeURIComponent(m[2].replace(/\+/g, ' ')); st.pages = 1; sync();
      return true;
    }
    function goTo() { setTimeout(function () { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120); }
    var fromUrl = fromHash();
    window.addEventListener('hashchange', function () { if (fromHash()) { render(); goTo(); } });
    var lastPer = per();
    window.addEventListener('resize', function () { if (per() !== lastPer) { lastPer = per(); render(); } });
    render();
    if (fromUrl) { goTo(); }
  }

  function addToCart(btn) {
    var id = Number(btn.dataset.variantId), qty = Math.max(1, Number(btn.dataset.qty) || 1);
    if (!id || btn.disabled) { return; }
    var label = btn.textContent;
    btn.classList.add('is-busy');
    var done = function (ok, msg) {
      btn.classList.remove('is-busy');
      btn.textContent = ok ? (btn.classList.contains('ess-add--icon') ? '✓' : 'Added') : (msg || 'Try again');
      setTimeout(function () { btn.textContent = label; }, 1800);
    };
    var core = window.themeCore;
    if (core && core.CartApi && core.CartApi.makeRequest) {
      Promise.resolve(core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, { id: id, quantity: qty }))
        .then(function () { done(true); try { core.CartApi.makeRequest(core.CartApi.actions.GET_CART); } catch (e) {} })
        .catch(function (err) { done(false, (err && err.description) ? 'Unavailable' : 'Try again'); });
      return;
    }
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) { if (!r.ok) { throw r; } done(true); window.location.href = '/cart'; })
      .catch(function () { done(false); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ess-add]') : null;
    if (b) { e.preventDefault(); addToCart(b); }
  });

  function openSheet(handle) {
    var p = products[handle];
    var dlg = $('[data-ess-sheet]');
    if (!p || !dlg || typeof dlg.showModal !== 'function') { return false; }
    var set = function (k, v) { var el = $('[data-s="' + k + '"]', dlg); if (el) { el.textContent = v || ''; } };
    set('no', 'No. ' + p.no);
    set('house', p.house + (p.origin ? ' · ' + p.origin : ''));
    set('name', p.name);
    set('meta', [p.conc, p.family + (p.sub ? ' — ' + p.sub : ''), p.year].filter(Boolean).join(' · ') + (p.perfumer ? ' · by ' + p.perfumer : ''));
    set('desc', p.desc);
    set('top', p.top || '—'); set('heart', p.heart || '—'); set('base', p.base || '—');
    var img = $('[data-s="img"]', dlg); img.innerHTML = '';
    if (p.image) { var i = document.createElement('img'); i.src = p.image; i.alt = p.house + ' ' + p.name; img.appendChild(i); }
    var tags = $('[data-s="tags"]', dlg); tags.innerHTML = '';
    (p.tags || []).filter(Boolean).forEach(function (t) { var s = document.createElement('span'); s.textContent = t; tags.appendChild(s); });
    $('[data-s="url"]', dlg).href = p.url;
    var btn = $('[data-s="add"]', dlg);
    var qty = 1;
    var setQty = function (n) { qty = Math.max(1, Math.min(10, n)); set('qty', String(qty)); btn.dataset.qty = qty; };
    $$('[data-ess-qty]', dlg).forEach(function (q) { q.onclick = function () { setQty(qty + Number(q.dataset.essQty)); }; });
    setQty(1);
    var sizes = $('[data-s="sizes"]', dlg); sizes.innerHTML = '';
    sizes.hidden = p.variants.length < 2;
    var pick = function (v) {
      set('price', v.price); set('perml', v.perMl || '');
      btn.dataset.variantId = v.id;
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      $$('button', sizes).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.id === String(v.id) ? 'true' : 'false'); });
    };
    p.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ess-chip'; b.textContent = v.title; b.dataset.id = v.id;
      b.addEventListener('click', function () { pick(v); });
      sizes.appendChild(b);
    });
    pick(p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]);
    dlg.showModal();
    return true;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ess-open]') : null;
    if (t) {
      if (openSheet(t.dataset.essOpen)) { e.preventDefault(); }
      else {
        var c = t.closest('[data-ess-card]'); var a = c && c.querySelector('a[href]');
        var url = t.dataset.essUrl || (a && a.href);
        if (url) { e.preventDefault(); window.location.href = url; }
      }
    }
    var close = e.target.closest ? e.target.closest('[data-ess-sheet-close]') : null;
    if (close) { close.closest('dialog').close(); }
    if (e.target.matches && e.target.matches('dialog[data-ess-sheet]')) { e.target.close(); }
  });

  function init(root) {
    readProducts(root);
    $$('[data-ess-acts]', root).forEach(function (s) { if (!s.essInit) { s.essInit = 1; initActs(s); } });
    $$('[data-ess-question]', root).forEach(function (s) { if (!s.essInit) { s.essInit = 1; initQuestion(s); } });
    $$('[data-ess-shelf]', root).forEach(function (s) { if (!s.essInit) { s.essInit = 1; initShelf(s); } });
  }
  window.EssIssue = { init: init, open: openSheet };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
